import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { QuotesSideActions } from '../../elements/QuotesSideActions'
import { QuotesSummary } from './elements/QuotesSummary'
import { QuotesTable } from './elements/QuotesTable'
import { QuotesTableActions } from './elements/QuotesTableActions'
import { useIsQuotesListEmpty } from './hooks/useIsQuotesListEmpty'

export const QuotesList = (): ReactElement | null => {
  const { t } = useTranslation()
  const { isQuotesListEmpty } = useIsQuotesListEmpty()
  const { url: quotesListEmptyUrl } = useOrganizationViewUrl(reactRoute.organization.quotes.getListEmptyRoute())

  if (!quotesListEmptyUrl) {
    return null
  }

  if (isQuotesListEmpty) {
    return <Navigate to={quotesListEmptyUrl} replace />
  }

  return (
    <ModuleLayout title={t('quotes')} sideActions={<QuotesSideActions />}>
      <QuotesSummary />
      <QuotesTableActions />
      <QuotesTable />
    </ModuleLayout>
  )
}
